import type { FaireProductEntity } from "../../entity_types/product";

export const p_xy86g89hcw: FaireProductEntity = {
  token: "p_xy86g89hcw",
  type: "product",
  name: "Inlaid Shell Pendant Necklace",
  brandToken: "b_jbt25unvjp",
  brandName: "Gooddiy",
  imageUrl: "https://cdn.faire.com/fastly/b36ca49c64fb1e7155754656fa81611866e68afd9ebee495fbcee5b65529deeb.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.93,
  description: "Wholesale Fashion Heart Shaped Titanium Steel Inlaid Shell Pendant Necklace, Style: Fashion, Design: Inlaid, Gender: Women, Pattern: Heart Shape, Material: Titanium Steel, Occasion: Daily, Quantity: 1 Piece, Chain Material: Titanium Steel, Classification: Pendant Necklace, Inlay Material: Shell, Pendant Material: Titanium Steel, Gold Plating Process: Vacuum Plating, Weight: 15g",
  tags: [],
  msrpDollars: 3.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:52.802Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
